module.exports = __webpack_public_path__ + "static/img/bg.065794be.jpg";